import { Button } from '@/Components/UI/Button/Button';

export const UnableFilters = ({
  text = ' OR logic present; filter can only be applied using advanced controls.',
  handleAdvanced,
}) => {
  return (
    <div className='w-auto bg-ui'>
      <div
        data-cy={'unable-filter-text'}
        className='text-ui-secondary text-[13px] italic leading-5 p-2'
      >
        {text}
      </div>
      <div className='flex flex-row items-center justify-between mt-[12px] text-right'>
        <div className='flex gap-1' />
        <div className=''>
          <Button
            onClick={handleAdvanced}
            className='px-2'
            size='small'
            color='shadow'
            iconName='gear'
            dataCy='qf-advanced'
          >
            Advanced
          </Button>
        </div>
      </div>
    </div>
  );
};
